import React, { ChangeEvent, useState } from 'react';

import { observer } from 'mobx-react-lite';

import theme from '@vromo/ui/components/theme';
import FontAwesome from '@vromo/ui/components/FontAwesome';

import { opacify } from 'polished';
import { css } from 'emotion';

import debounce from 'lodash/debounce';

const className = css`
    position: relative;
    flex: 1;
    padding-left: 10px;

    i {
        position: absolute;
        left: 15px;
        bottom: 11px;
    }

    input {
        width: 100%;
        padding: 6px 12px 6px 25px;
        border: none;
        outline: none;
        margin-bottom: 4px;
        border-bottom: 1px solid ${opacify(-0.7, theme.primary)};
        transition: all 200ms ease-in-out;

        ::placeholder {
            color: ${theme.grey};
            transition: all 200ms ease-in-out;
        }

        &:focus {
            border-color: ${theme.primary};
            box-shadow: none;
            outline: 0;

            ::placeholder {
                color: transparent;
            }
        }
    }
`;

export default observer<{ value: string; onChange: (e: string) => void }>(
    function ListSearch({ value, onChange }) {
        const [inputText, setInputText] = useState(value);

        const updateSearch = debounce(onChange, 300);
        const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
            setInputText(e.target.value);
            updateSearch(e.target.value);
        }
        return (
            <div className={className}>
                <FontAwesome
                    icon="search"
                    weight="regular"
                    className={css`
                        color: ${theme.primary};
                    `}
                />
                <input
                    value={inputText}
                    placeholder="Search"
                    onChange={handleSearchChange}
                />
            </div>
        );
    }
);
